// External
import { CookieService } from 'ngx-cookie-service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError, map, catchError } from 'rxjs';

// Internal
import { ValuesService } from '../../../values/values.service';
import { POST, RequestsService } from '../../global/request-service/requests.service';
import { DeleteFileModel, FileModel, FileDetailsModel } from '../../../../common/models/Katastif.model';
import { ConfigService } from '../../../../common/config/config.service';

export enum KatastifServiceLocation {
    CONNECT_RESOURCES = 'connect-resources',
    SNAP_PHOTO = 'snap-photo'
}

@Injectable({
  providedIn: 'root'
})

export class KatastifManagerService {
    private readonly defaultErrorMessage = 'Invalid params';

    constructor(
        private readonly cookiesService: CookieService,
        private readonly http: HttpClient,
        private readonly requestService: RequestsService,
        private readonly valuesService: ValuesService,
        private readonly configService: ConfigService
    ) {}

    uploadFile(file): Observable<FileModel> {
        if (!file) {
            return throwError(() => new Error(this.defaultErrorMessage));
        }

        const json = {
            id: parseInt((Math.random() * 100).toString(), 10),
            jsonrpc: this.valuesService.jsonrpc,
            method: 'add',
            params: {
                connect_source: {
                    user_token: this.cookiesService.get(this.valuesService.cookieToken),
                    device_id: this.valuesService.connectDeviceId,
                    app_id: this.valuesService.connectAppId
                },
                file_size: file.size,
                metadata: {
                    content_type: file.type,
                    file_name: file.name
                },
                service: KatastifServiceLocation.CONNECT_RESOURCES
            }
        };

        return this.requestService.make(
            this.configService.config.katastifServer,
            this.valuesService.katastifService,
            json,
            POST
        ).pipe(
            map(res =>  res.result),
            catchError(error => {
                throw error;
            })
        );
    }

    deleteFile(fileId): Observable<DeleteFileModel> {
        if (!fileId) {
            return throwError(() => new Error(this.defaultErrorMessage));
        }

        const json = {
            id: parseInt((Math.random() * 100).toString(), 10),
            method: 'remove',
            params: {
                connect_source: {
                    user_token: this.cookiesService.get(this.valuesService.cookieToken),
                    device_id: this.valuesService.connectDeviceId,
                    app_id: this.valuesService.connectAppId
                },
                service: KatastifServiceLocation.CONNECT_RESOURCES,
                id: fileId
            }
        };

        return this.requestService.make(
            this.configService.config.katastifServer,
            this.valuesService.katastifService,
            json,
            POST
        ).pipe(
            map(res => res.result),
            catchError(error => {
                throw error;
            })
        );
    }

    getFile(result, serviceLocation): Observable<FileDetailsModel> {
        if (!result) {
            return throwError(() => new Error(this.defaultErrorMessage));
        }

        const json = {
            id: parseInt((Math.random() * 100).toString(), 10),
            jsonrpc: this.valuesService.jsonrpc,
            method: 'get',
            params: {
                connect_source: {
                    user_token: this.cookiesService.get(this.valuesService.cookieToken),
                    device_id: this.valuesService.connectDeviceId,
                    app_id: this.valuesService.connectAppId
                },
                id: result.file_uid,
                redirect: false,
                service: serviceLocation
            }
        };

        return this.requestService.make(
            this.configService.config.katastifServer,
            this.valuesService.katastifService,
            json,
            POST
        ).pipe(
            map(res => res.result),
            catchError(error => {
                throw error;
            })
        );
    }

    getMdIdFile(uri, file): Observable<{}> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type':  'application/octet-stream'
            })
        };
        return this.http.post(uri, file, httpOptions);
    }
}
